import { Box, Button, Heading, Image, Text, SimpleGrid, VStack } from '@chakra-ui/react';
import ContentErrorHandler from 'components/ContentErrorHandler';
import { BLUE, BLUE_DARKER } from 'constants/colors';
import { useNavigate } from 'react-router-dom';
import { useGetUmkmCategoriesQuery } from './api';

export default function UmkmCategoryList() {
  const navigate = useNavigate();
  const { data: categories, error, isLoading } = useGetUmkmCategoriesQuery();

  return (
    <ContentErrorHandler isError={error} isLoading={isLoading}>
      <Box bg="white" minH="100vh" py={10}>
        <Box display="flex" flexDirection="column" gap={8} maxW="1200px" mx="auto" px={4} alignItems="stretch" as="div">
          <Box as="h2" fontSize="2xl" fontWeight="bold" color={BLUE_DARKER} textAlign="center">
            UMKM Binaan Credit Union Madani
          </Box>

          <Box display="grid" gridTemplateColumns={{ base: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }} gap={6} w="100%">
            {categories?.map((category) => (
              <Box
                key={category.id}
                overflow="hidden"
                cursor="pointer"
                transition="transform 0.2s"
                _hover={{ transform: 'scale(1.05)', shadow: 'xl' }}
                onClick={() => navigate(`/umkm/category/${category.id}`)}
                bg="white"
                borderRadius="md"
                shadow="md"
              >
                {category.image && <Box as="img" src={category.image} alt={category.name} h="200px" w="100%" objectFit="cover" />}
                <Box p={4}>
                  <Box display="flex" flexDirection="column" gap={3}>
                    <Box as="h3" fontSize="md" fontWeight="bold" color={BLUE}>
                      {category.name}
                    </Box>
                    {category.description && (
                      <Box color="gray.600" noOfLines={3} fontSize="sm">
                        {category.description}
                      </Box>
                    )}
                    <Box
                      as="button"
                      bg={BLUE}
                      color="white"
                      px={4}
                      py={2}
                      borderRadius="md"
                      border="none"
                      cursor="pointer"
                      fontSize="sm"
                      fontWeight="500"
                    >
                      Lihat UMKM
                    </Box>
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>

          {(!categories || categories.length === 0) && !isLoading && (
            <Box fontSize="lg" color="gray.500">
              Belum ada kategori UMKM
            </Box>
          )}
        </Box>
      </Box>
    </ContentErrorHandler>
  );
}
